import React from 'react';

const MultiLevelLink = ({ children, icon, title }) => {
  return (
    <li className="gjs-tablinks multi-level" title={title}>
      <i className={`wb ${icon}`}></i>
      {children}
    </li>
  );
};

export default MultiLevelLink;
